<template>
  <div
    :class="`traveler-occupancy-input traveler-occupancy-input--${occupancy_alignment}`"
    v-click-outside="hide_occupancy"
  >
    <button
      class="traveler-occupancy-input__button cursor-pointer"
      @click="toggle_occupancy"
    >
      <b-form-input
        ref="input-occupancy"
        id="input-occupancy"
        :placeholder="occupancy_placeholder"
        class="vb-input"
      />
      <div class="traveler-occupancy-input__icon">
        <vb-icon :name="'occupants'" :color="sass('primary')" :size="20" />
      </div>
      <div class="traveler-occupancy-input__arrow">
        <vb-icon
          :name="'angle_small_down'"
          :color="sass('primary')"
          :size="24"
        />
      </div>
    </button>
    <occupancy
      v-show="show_occupancy"
      @close="hide_occupancy"
      @updated="on_occupancy_updated"
      :max_adults="max_adults"
      :max_children="max_children"
    />
  </div>
</template>

<script>
import Occupancy from "@liveflight/components/blocks/booking-engine/occupancy";
import { buildTravelersArray } from "./logic";

export default {
  name: "traveler-occupancy-input",
  components: {
    occupancy: Occupancy,
  },
  props: {
    travelers: {
      type: Array,
      required: true,
      default: () => [],
    },
    max_adults: {
      type: Number,
      required: true,
      default: 9,
    },
    max_children: {
      type: Number,
      required: true,
      default: 9,
    },
    occupancy_alignment: {
      type: String,
      default: () => "auto",
    },
  },
  data() {
    return {
      show_occupancy: false,
    };
  },
  computed: {
    occupancy_placeholder() {
      return `${this.travelers.length} passegger${
        this.travelers.length === 1 ? "o" : "i"
      }`;
    },
  },
  methods: {
    toggle_occupancy() {
      this.show_occupancy = !this.show_occupancy;
    },
    hide_occupancy() {
      this.show_occupancy = false;
    },
    on_occupancy_updated(occupancy) {
      const updated_travelers = buildTravelersArray(occupancy);

      this.$emit("update:travelers", updated_travelers);
      this.$emit("update:adults", occupancy.adults);
      this.$emit("update:children", occupancy.children);
    },
  },
};
</script>

<style lang="scss" scoped>
.traveler-occupancy-input {
  width: 100%;

  &__button {
    position: relative;
    width: 100%;
    height: $input-height;
    padding: 0;
    margin: 0;
    border: none;
    background: transparent;
    text-align: left;

    input {
      height: 100%;
      padding-left: 40px;
      border: 1px solid var(--primary);
      pointer-events: none;
      &::placeholder {
        font-size: $font-size-base;
        color: var(--text);
      }
    }
  }

  &__icon {
    position: absolute;
    top: 50%;
    left: 10px;
    height: 26px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }

  &__arrow {
    position: absolute;
    top: 50%;
    right: 10px;
    height: 24px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__text {
    align-items: center;
    justify-content: center;
    justify-items: center;
    display: flex;
    gap: 5px;
  }

  ::v-deep .occupancy {
    position: absolute;
    top: 100%;
    margin-top: 5px;
    left: 0;
    z-index: 9999;
    background: $white;
    border: 1px solid $gray-200;
    border-radius: $btn-border-radius;
    box-shadow: $box-shadow-sm;

    @include media-breakpoint-up(md) {
      left: auto;
      right: 0;
    }

    @include media-breakpoint-down(sm) {
      position: static;
      margin-top: 0;
    }
  }

  &--end {
    ::v-deep .occupancy {
      left: 0;
      right: auto;
    }
  }
}
</style>
